module.exports = __webpack_public_path__ + "clear_filters.b0f17b112196feaac7f2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/clear_filters.svg
// module id = ./src/assets/img/clear_filters.svg
// module chunks = main